import { Link } from "react-router-dom";
import { PageHeader } from "../ui";

export function NotFoundPage() {
  return (
    <>
      <PageHeader eyebrow="— 404" title="Not found" />
      <p className="text-slate-600">
        There is nothing at this address.{" "}
        <Link to="/ads">Back to your ads.</Link>
      </p>
    </>
  );
}
